import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
    return (
        <div className="page">
            <img src="/kaloai.png" alt="KaloAI" className="app-logo" />
            <h1>WARUNKI ŚWIADCZENIA USŁUG KALOAI</h1>

            <p><Link to="/" className="router-link">← Powrót do strony głównej</Link></p>

            <p><strong>Data ostatniej aktualizacji: 15 stycznia 2025</strong></p>

            <h2>1. INFORMACJE OGÓLNE</h2>

            <p>Niniejsze Warunki Świadczenia Usług (dalej: "Warunki") regulują korzystanie z aplikacji mobilnej 
                KaloAI (dalej: "Aplikacja") udostępnianej przez BLONEKDEV (dalej: "my", "nas", "nasz").</p>

            <p>Korzystając z Aplikacji, akceptujesz niniejsze Warunki w całości. Jeśli nie zgadzasz się 
                z którymkolwiek z tych warunków, nie korzystaj z Aplikacji.</p>

            <h2>2. DANE DOSTAWCY USŁUG</h2>

            <p><strong>Dostawca usług:</strong></p>

            <ul>
                <li>Nazwa: BLONEKDEV</li>
                <li>Adres: ul. Mławka 25, Iłowo-Osada, Polska</li>
                <li>E-mail: blonekdev@gmail.com</li>
                <li>Telefon: +48 698404252</li>
            </ul>

            <h2>3. OPIS USŁUG</h2>

            <h3>3.1 Podstawowe funkcje</h3>

            <p>KaloAI to aplikacja do śledzenia kalorii z wykorzystaniem sztucznej inteligencji, która oferuje:</p>

            <ul>
                <li>Analizę zdjęć żywności przy użyciu AI</li>
                <li>Automatyczne obliczanie kalorii i makroskładników</li>
                <li>Śledzenie dziennych celów żywieniowych</li>
                <li>Prowadzenie dziennika żywienia</li>
                <li>Monitoring postępów</li>
            </ul>

            <h3>3.2 Funkcje Premium</h3>

            <p>Subskrypcja Premium zapewnia dostęp do dodatkowych funkcji:</p>

            <ul>
                <li>Nieograniczona analiza zdjęć</li>
                <li>Szczegółowe raporty żywieniowe</li>
                <li>Eksport danych</li>
                <li>Zaawansowane cele żywieniowe</li>
                <li>Priorytetowa obsługa klienta</li>
            </ul>

            <h2>4. KONTO UŻYTKOWNIKA</h2>

            <h3>4.1 Rejestracja</h3>

            <ul>
                <li>Musisz mieć co najmniej 16 lat, aby korzystać z Aplikacji</li>
                <li>Podane przez Ciebie informacje muszą być prawdziwe i aktualne</li>
                <li>Jesteś odpowiedzialny za bezpieczeństwo swojego konta</li>
                <li>Natychmiast powiadom nas o podejrzeniu nieautoryzowanego dostępu</li>
            </ul>

            <h3>4.2 Odpowiedzialność użytkownika</h3>

            <ul>
                <li>Nie udostępniaj swojego konta innym osobom</li>
                <li>Korzystaj z Aplikacji zgodnie z jej przeznaczeniem</li>
                <li>Nie przesyłaj treści nielegalnych lub szkodliwych</li>
                <li>Przestrzegaj wszystkich obowiązujących przepisów prawa</li>
            </ul>

            <h2>5. WYKORZYSTANIE SZTUCZNEJ INTELIGENCJI</h2>

            <h3>5.1 Analiza zdjęć</h3>

            <ul>
                <li>AI analizuje zdjęcia żywności w celu oszacowania wartości odżywczych</li>
                <li>Wyniki są przybliżone i mogą zawierać błędy</li>
                <li>Aplikacja nie zastępuje profesjonalnej porady dietetycznej</li>
                <li>Zdjęcia są przetwarzane zgodnie z naszą Polityką Prywatności</li>
            </ul>

            <h3>5.2 Ograniczenia dokładności</h3>

            <p>Pamiętaj, że:</p>

            <ul>
                <li>Oszacowania AI są przybliżone</li>
                <li>Dokładność zależy od jakości zdjęcia</li>
                <li>Niektóre produkty mogą być nieprawidłowo rozpoznane</li>
                <li>Zawsze możesz ręcznie skorygować wyniki</li>
            </ul>

            <h2>6. PŁATNOŚCI I SUBSKRYPCJE</h2>

            <h3>6.1 Plany subskrypcji</h3>

            <ul>
                <li><strong>Plan miesięczny</strong>: Opłata pobierana co miesiąc</li>
                <li><strong>Plan roczny</strong>: Opłata pobierana co rok z rabatem</li>
                <li>Ceny mogą się różnić w zależności od regionu</li>
                <li>Wszystkie ceny zawierają podatek VAT</li>
            </ul>

            <h3>6.2 Automatyczne odnowienie</h3>

            <ul>
                <li>Subskrypcje są automatycznie odnawiane</li>
                <li>Opłata jest pobierana 24 godziny przed wygaśnięciem</li>
                <li>Możesz anulować w każdej chwili w ustawieniach sklepu</li>
                <li>Anulowanie nie wpływa na bieżący okres rozliczeniowy</li>
            </ul>

            <h3>6.3 Zwroty</h3>

            <ul>
                <li>Zwroty są obsługiwane przez App Store lub Google Play</li>
                <li>Stosuj się do polityki zwrotów odpowiedniego sklepu</li>
                <li>W wyjątkowych przypadkach skontaktuj się z nami bezpośrednio</li>
            </ul>

            <h2>7. DOZWOLONE WYKORZYSTANIE</h2>

            <h3>7.1 Akceptowalne zachowania</h3>

            <ul>
                <li>Korzystanie z Aplikacji do śledzenia żywienia</li>
                <li>Przesyłanie zdjęć żywności do analizy</li>
                <li>Udostępnianie konstruktywnych opinii</li>
                <li>Eksportowanie własnych danych</li>
            </ul>

            <h3>7.2 Zabronione działania</h3>

            <p>Nie wolno Ci:</p>

            <ul>
                <li>Kopiować, modyfikować lub dystrybuować Aplikacji</li>
                <li>Podejmować prób nieautoryzowanego dostępu do systemów</li>
                <li>Przesyłać treści nieprzyzwoitych, nielegalnych lub szkodliwych</li>
                <li>Wykorzystywać Aplikacji do celów komercyjnych bez zgody</li>
                <li>Zakłócać działanie Aplikacji lub jej użytkowników</li>
                <li>Tworzyć fałszywych kont lub podszywać się pod inne osoby</li>
            </ul>

            <h2>8. WŁASNOŚĆ INTELEKTUALNA</h2>

            <h3>8.1 Nasze prawa</h3>

            <ul>
                <li>Aplikacja i jej zawartość są chronione prawem autorskim</li>
                <li>Zachowujemy wszystkie prawa do Aplikacji</li>
                <li>Znaki towarowe KaloAI należą do BLONEKDEV</li>
                <li>Nie uzyskujesz żadnych praw własności do Aplikacji</li>
            </ul>

            <h3>8.2 Twoje dane</h3>

            <ul>
                <li>Zachowujesz własność do przesyłanych przez Ciebie treści</li>
                <li>Udzielasz nam licencji na wykorzystanie tych treści do świadczenia usług</li>
                <li>Możesz usunąć swoje dane w każdej chwili</li>
            </ul>

            <h2>9. DOSTĘPNOŚĆ USŁUG</h2>

            <h3>9.1 Czas dostępności</h3>

            <ul>
                <li>Dążymy do zapewnienia ciągłej dostępności Aplikacji</li>
                <li>Możliwe są przerwy związane z konserwacją</li>
                <li>O planowanych przerwach informujemy z wyprzedzeniem</li>
                <li>Nie gwarantujemy 100% dostępności usług</li>
            </ul>

            <h3>9.2 Aktualizacje</h3>

            <ul>
                <li>Regularnie udostępniamy aktualizacje Aplikacji</li>
                <li>Niektóre aktualizacje mogą być wymagane</li>
                <li>Stare wersje mogą przestać być obsługiwane</li>
            </ul>

            <h2>10. WYŁĄCZENIE ODPOWIEDZIALNOŚCI</h2>

            <h3>10.1 Charakter usług</h3>

            <p>Aplikacja jest świadczona "jak jest" i "jak dostępna". Nie gwarantujemy:</p>

            <ul>
                <li>Bezprzerwowego działania</li>
                <li>Braku błędów</li>
                <li>Pełnej dokładności analiz AI</li>
                <li>Zgodności z Twoimi oczekiwaniami</li>
            </ul>

            <h3>10.2 Ograniczenie odpowiedzialności</h3>

            <ul>
                <li>Aplikacja nie zastępuje porady medycznej lub dietetycznej</li>
                <li>Nie ponosimy odpowiedzialności za decyzje żywieniowe podjęte na podstawie Aplikacji</li>
                <li>Nasza odpowiedzialność jest ograniczona do wartości opłaconej subskrypcji</li>
                <li>Nie odpowiadamy za szkody pośrednie lub przypadkowe</li>
            </ul>

            <h2>11. ROZWIĄZANIE UMOWY</h2>

            <h3>11.1 Rozwiązanie przez użytkownika</h3>

            <ul>
                <li>Możesz zaprzestać korzystania z Aplikacji w każdej chwili</li>
                <li>Możesz usunąć swoje konto w ustawieniach</li>
                <li>Anulowanie subskrypcji w odpowiednim sklepie</li>
            </ul>

            <h3>11.2 Rozwiązanie przez nas</h3>

            <p>Możemy zawiesić lub usunąć Twoje konto w przypadku:</p>

            <ul>
                <li>Naruszenia niniejszych Warunków</li>
                <li>Podejrzenia o nieuprawnione korzystanie</li>
                <li>Braku płatności za subskrypcję</li>
                <li>Nieaktywności przez długi okres</li>
            </ul>

            <h2>12. ZMIANY WARUNKÓW</h2>

            <p>Zastrzegamy sobie prawo do zmiany niniejszych Warunków. O istotnych zmianach powiadomimy Cię:</p>

            <ul>
                <li>Przez powiadomienie w Aplikacji</li>
                <li>E-mailem (jeśli wyrazisz zgodę)</li>
                <li>Poprzez aktualizację w App Store</li>
            </ul>

            <p>Kontynuowanie korzystania z Aplikacji po wprowadzeniu zmian oznacza ich akceptację.</p>

            <h2>13. PRAWO WŁAŚCIWE I JURYSDYKCJA</h2>

            <ul>
                <li>Niniejsze Warunki podlegają prawu polskiemu</li>
                <li>Spory będą rozstrzygane przez sądy polskie</li>
                <li>W pierwszej kolejności dążymy do polubownego rozwiązania sporów</li>
            </ul>

            <h2>14. KONTAKT</h2>

            <p>W przypadku pytań dotyczących niniejszych Warunków, skontaktuj się z nami:</p>

            <p><strong>E-mail</strong>: blonekdev@gmail.com<br />
                <strong>Adres</strong>: ul. Mławka 25, Iłowo-Osada, Polska
            </p>

            <h2>15. POSTANOWIENIA KOŃCOWE</h2>

            <h3>15.1 Rozdzielność postanowień</h3>

            <p>Jeśli którekolwiek z postanowień niniejszych Warunków zostanie uznane za nieważne, 
                pozostałe postanowienia pozostają w mocy.</p>

            <h3>15.2 Całość umowy</h3>

            <p>Niniejsze Warunki wraz z Polityką Prywatności stanowią całość umowy między nami.</p>

            <h3>15.3 Brak zrzeczenia się praw</h3>

            <p>Niewykonywanie przez nas któregokolwiek z naszych praw nie oznacza zrzeczenia się tego prawa.</p>

            <hr />

            <p><strong>Ostatnia aktualizacja</strong>: 15 stycznia 2025<br />
                <strong>Wersja</strong>: 1.0
            </p>

            <p>Zachęcamy do zapoznania się z naszą <Link to="/privacy" className="router-link">
                Polityką Prywatności</Link>, która uzupełnia niniejsze Warunki.</p>
        </div>
    );
};

export default TermsPage;